<div class="row">
    <div *ngIf="needConfig == true" class="col-md-12 need-config">
        <div class="row">
            <div class="col-md-4 offset-md-4">
                <div class="card block shadow">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Sélection de la ville</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">
                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Ville et/ou code postal</mat-label>
                                    <input type="text"
                                           class="text"
                                           matInput
                                           [(ngModel)]="name"
                                           [formControl]="cityControl"
                                           [matAutocomplete]="auto">
                                    <mat-autocomplete (optionSelected)='changeCity($event.option.value)' autoActiveFirstOption #auto="matAutocomplete">
                                        <mat-option *ngFor="let city of cities" [value]="city">
                                            {{city.name}}
                                            ({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})
                                        </mat-option>
                                    </mat-autocomplete>
                                    <span matSuffix><div class="citySpinner" style="display: none;"><mat-spinner diameter="20"></mat-spinner></div></span>
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <a class="btn d-block" (click)="showResults()">
                                    Valider
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
